import * as React from 'react';
import { Dropdown } from './../Dropdown/dropdown';
import { Add as AddButton } from 'rcd-cpp-ui/ui/button';
import './newIdeaMenu.scss';
import { TriggerLocation } from '../../enums/TriggerLocation';
import { Metadata } from '../../types/Metadata';
import { FieldType } from '../../enums/FieldType';
import { NodeType } from '../../enums/NodeType';
import { useActions as useFormActions } from '../MetadataForm/metadataFormActions';
import { useSelector } from '../../utils/useSelector';
import { Primary } from 'rcd-cpp-ui/ui/button';
import { Add } from '../Icon/icon';
import TooltipPopover from '../Popover/popover';
import { getSchema } from '../../utils';
import { ItemType } from '../../enums/ItemType';

interface NewIdeaMenuProps {
  position?;
  triggerLocation: TriggerLocation;
  group?;
}

enum OptionName {
  AddContentItem = 'New Item',
  AddConferenceItem = 'New Item'
}

export const NewIdeaMenu = ({
  position,
  triggerLocation,
  group
}: NewIdeaMenuProps) => {
  const permittedNewItemTypes = useSelector(
    s => s.planning?.selectedWorkspace?.props?.allowAddNewItems
  );
  const dataSchema = useSelector(s =>
    getSchema(s.planning?.selectedWorkspace?.schemas, NodeType.Item)
  );
  const { showForm } = useFormActions();

  const onSelect = o => {
    let m = {
      props: {},
      triggerLocation
    } as Metadata;
    if (!!group && group.props) {
      const f = dataSchema?.props?.fields?.filter(
        f =>
          f.fieldType == FieldType.reference &&
          group.labels.includes(f.dataType as NodeType)
      )[0];
      if (f) {
        m.props[f.field] = [group];
      }
    }
    m.props.itemType = o.itemType;
    showForm(m, dataSchema);
  };
  const buttonText = 'New Planning Item';
  const options = [
    {
      name: OptionName.AddContentItem,
      Icon: Add,
      displayName: 'Content',
      itemType: ItemType.content
    },
    {
      name: OptionName.AddConferenceItem,
      Icon: Add,
      displayName: 'Conferences',
      itemType: ItemType.globalSubmission
    }
  ];

  const filteredOptions =
    permittedNewItemTypes != null && permittedNewItemTypes?.length
      ? options.filter(o => permittedNewItemTypes.includes(o.itemType))
      : options;

  const handleNewItemClick = (onClick: () => void) => {
    switch (triggerLocation) {
      case TriggerLocation.NAV:
        return (
          <Primary onClick={onClick}>
            <Add inverted />
            {buttonText}
          </Primary>
        );
      case TriggerLocation.VIEW:
        return (
          <AddButton
            buttonSize="small"
            className="view-button"
            onClick={onClick}
          />
        );
      case TriggerLocation.BOARD_GROUP:
        return (
          <TooltipPopover type={'info'} content={buttonText} packed={true}>
            <div className="board-group-add" onClick={onClick}>
              +
            </div>
          </TooltipPopover>
        );
      default:
        return null;
    }
  };

  if (filteredOptions?.length == 1) {
    return (
      <div className="new-idea-menu">
        {handleNewItemClick(() => onSelect(filteredOptions[0]))}
      </div>
    );
  }

  return (
    <div className="new-idea-menu">
      <Dropdown
        options={filteredOptions}
        position={position}
        onSelect={onSelect}
        renderOption={o => {
          const I = o.Icon;
          return (
            <>
              <div>{o.displayName}</div>
              <div>
                <span>{I && <I />}</span>
                <span className="dd-text" data-txt={o.name}>
                  {o.name}
                </span>
              </div>
            </>
          );
        }}
      >
        {handleNewItemClick(() => {})}
      </Dropdown>
    </div>
  );
};
